import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Anchor,
  Type,
  Flex,
  UpdateBadge,
} from "discover.medical.react-component-library";
import { StyledTextContainer, StyledAlgorithmLogo } from "./_.styled";

const ViewInTopicLink = ({ topic }) => {
  const link = `${topic.slug}#${topic.linkId}`;
  return (
    <Anchor linkComponent={Link} href={link} fontSize="sm">
      {topic.title}
    </Anchor>
  );
};

ViewInTopicLink.propTypes = {
  topic: PropTypes.shape({
    title: PropTypes.string,
    slug: PropTypes.string,
    linkId: PropTypes.string,
  }),
};

const ALGORITHM_LOGO_URL =
  "https://resources.dynamed.com/discover.medical.mfe-container/assets/images/Algorithm_Update_Icon.svg";

export const Alert = ({ alert, className }) => {
  return (
    <div className={className}>
      <UpdateBadge
        priority={alert.priority}
        showSubPriority={alert.healthEquity}
        subPriorityBackground="primary"
        text={alert.type}
        timestamp={+alert.timestamp}
      />
      <Flex container row marginTop="xs">
        {alert.type === "Algorithm" && (
          <StyledAlgorithmLogo alt="Algorithm logo" src={ALGORITHM_LOGO_URL} />
        )}
        <StyledTextContainer>
          <Type element="p" marginBottom="xs">
            {alert.text}
          </Type>
          <Type element="p" fontSize="sm">
            View in{" "}
            {alert.topics.map((topic, index) => {
              return (
                <span key={index}>
                  <ViewInTopicLink topic={topic} />
                  {index !== alert.topics.length - 1 && ", "}
                </span>
              );
            })}
          </Type>
        </StyledTextContainer>
      </Flex>
    </div>
  );
};

Alert.propTypes = {
  alert: PropTypes.shape({
    updatesText: PropTypes.string,
    relevantTopics: PropTypes.array,
  }),
};

export default Alert;
